/// <amd-module name="Repos/Discussion/Components/AddComment" />
import * as React from "react";
import * as Resources from "Repos/Discussion/Resources";
import { Button } from "VSSUI/Button";
import { Observer } from "VSSUI/Observer";
import { IAddCommentProps } from "./AddComment.Props";
import { EditComment } from "./EditComment";

export const AddComment = (props: IAddCommentProps): JSX.Element => {
    const { author, className, comment, markdownEditorProps, onCancel, onComment, personaProvider } = props;

    const submitChanges = (): void => {
        const content = comment.getContent().value;
        content && onComment && onComment(comment.getId(), content);
    };

    const buttons = (
        <Observer hasContent={comment.hasContent()} saving={comment.isSaving()}>
            {(commentProps: { hasContent: boolean; saving: boolean }) => {
                return (
                    <>
                        <Button disabled={commentProps.saving} onClick={onCancel}>
                            {Resources.CancelButtonText}
                        </Button>
                        <Button disabled={!commentProps.hasContent || commentProps.saving} onClick={() => submitChanges()} primary={true}>
                            {Resources.CommentButtonText}
                        </Button>
                    </>
                );
            }}
        </Observer>
    );

    return (
        <EditComment
            author={author}
            buttons={buttons}
            className={className}
            comment={comment.getContent()}
            dirty={comment.isDirty()}
            error={comment.getError()}
            markdownEditorProps={markdownEditorProps}
            onCancel={onCancel}
            onChange={newComment => comment.setContent(newComment)}
            onError={error => comment.setError(error)}
            onSubmit={submitChanges}
            personaClassName="margin-top-4"
            personaProvider={personaProvider}
            saving={comment.isSaving()}
        />
    );
};
